import {
  Building2,
  CalendarRange,
  Crown,
  Gift,
  LayoutDashboard,
  LayoutTemplate,
  Link2,
  PlusSquare,
  Sparkles,
  Ticket,
  UserRoundPen,
} from 'lucide-react';
import routes from '@/routes/routes.json';

/**
 * The whole navigation, as data.
 *
 * Both the expanded sidebar and the collapsed icon rail render from this one
 * list, which is what stops the two from drifting — the rail is a projection of
 * the nav, not a second copy of it. The group order is the vendor's day: what
 * they run today, then the venues behind it, then growth, then account.
 */

export interface NavLink {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  /** Match child routes too — `/dashboard/bookings/123` lights up "Bookings". */
  matchPrefix?: boolean;
  /** Gated behind a completed vendor profile. */
  requiresProfile?: boolean;
  /** Renders the "Soon" tag and blocks navigation. */
  comingSoon?: boolean;
}

export interface NavGroup {
  /** Uppercase heading in the sidebar; its initial labels the icon rail. */
  title: string;
  items: NavLink[];
}

export const NAV: NavGroup[] = [
  {
    title: 'Operations',
    items: [
      { to: routes.dashboard, label: 'Dashboard', icon: LayoutDashboard },
      {
        to: routes.venueManagement,
        label: 'Slot Manager',
        icon: CalendarRange,
        matchPrefix: true,
        requiresProfile: true,
      },
      {
        to: routes.venueBookings,
        label: 'Bookings',
        icon: Ticket,
        matchPrefix: true,
        requiresProfile: true,
      },
      {
        to: routes.offerManagement,
        label: 'Offers',
        icon: Gift,
        matchPrefix: true,
        requiresProfile: true,
      },
    ],
  },
  {
    title: 'Venues',
    items: [
      {
        to: routes.venueList,
        label: 'All venues',
        icon: Building2,
        matchPrefix: true,
        requiresProfile: true,
      },
      {
        to: routes.venueOnboard,
        label: 'Add a venue',
        icon: PlusSquare,
        matchPrefix: true,
        requiresProfile: true,
      },
    ],
  },
  {
    title: 'Growth',
    items: [
      {
        to: routes.venueRecommendation,
        label: 'Promote venue',
        icon: Crown,
        matchPrefix: true,
        requiresProfile: true,
      },
      {
        to: routes.mywebsite,
        label: 'My website',
        icon: LayoutTemplate,
        matchPrefix: true,
        requiresProfile: true,
      },
      {
        to: routes.DirectBookingLink,
        label: 'Booking link',
        icon: Link2,
        matchPrefix: true,
        requiresProfile: true,
      },
    ],
  },
  {
    title: 'Account',
    items: [
      { to: routes.profile, label: 'Profile', icon: UserRoundPen, requiresProfile: true },
      // Reserved for the assistant. It ships disabled so the slot is designed
      // for and budgeted in the layout now, rather than squeezed in later.
      { to: '#', label: 'AI assistant', icon: Sparkles, comingSoon: true },
    ],
  },
];
